// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25tef","index":"styles_index__ajAR1"};